import type { SVGProps } from 'react';

export const Copy = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.05 17.5q-.75 0-1.275-.525A1.74 1.74 0 0 1 7.25 15.7V4.3q0-.75.525-1.275T9.05 2.5h8.4q.75 0 1.275.525T19.25 4.3v11.4q0 .75-.525 1.275t-1.275.525zm0-1.5h8.4q.1 0 .2-.1t.1-.2V4.3q0-.1-.1-.2t-.2-.1h-8.4q-.1 0-.2.1t-.1.2v11.4q0 .1.1.2t.2.1m-3.5 5q-.75 0-1.275-.525A1.74 1.74 0 0 1 3.75 19.2V7.05q0-.3.2-.525A.75.75 0 0 1 4.5 6.3q.325 0 .525.225a.72.72 0 0 1 .225.525V19.2q0 .1.1.2t.2.1h9.15q.3 0 .525.225.225.2.225.525t-.225.55a.77.77 0 0 1-.525.2zm3.2-5V4z" />
    </svg>
  );
};
